<template>
    <ButtonLink size="m" :onClick="onClick" :automaticPosition="false">
        {{ details }}
    </ButtonLink>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { useStore } from '@/store';
    import { computed, defineComponent, PropType } from 'vue';
    import { ModalType, ProductModalTab } from '@/store/general/types';
    import { ProductRowItem } from '../types';
    import { trackClarity } from '@/tracking/clarity';
    import { ClarityEvent } from '@/tracking/clarity/types';
    import { logStatsigCheckoutShowPriceBreakdownDetails } from '@/tracking/statsig/checkout.functions';
    import ButtonLink from '@ui/components/Button/ButtonLink.vue';

    export default defineComponent({
        name: 'RowDetails',
        methods: { t },
        components: {
            ButtonLink,
        },
        props: {
            item: {
                type: Object as PropType<ProductRowItem>,
                required: true,
            },
        },
        setup(props) {
            const store = useStore();

            const product = computed(() => props.item.product);

            const details = t({ key: 'shared.details' });

            const onClick = () => {
                if (product.value) {
                    trackClarity(ClarityEvent.CHECKOUT_PRICE_BREAKDOWN_DETAILS_OPEN);

                    logStatsigCheckoutShowPriceBreakdownDetails(product.value.$type);

                    store.dispatch('general/setModal', {
                        type: ModalType.Product,
                        productId: product.value.Id,
                        activeTab: ProductModalTab.Details,
                    });
                }
            };

            return {
                details,
                onClick,
            };
        },
    });
</script>
